import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::index
* @see app/Http/Controllers/Admin/DocumentTypeController.php:156
* @route '/api/admin/placeholders'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/api/admin/placeholders',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::index
* @see app/Http/Controllers/Admin/DocumentTypeController.php:156
* @route '/api/admin/placeholders'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::index
* @see app/Http/Controllers/Admin/DocumentTypeController.php:156
* @route '/api/admin/placeholders'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DocumentTypeController::index
* @see app/Http/Controllers/Admin/DocumentTypeController.php:156
* @route '/api/admin/placeholders'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

const placeholders = {
    index: Object.assign(index, index),
}

export default placeholders